<template>
  <el-dialog :title="$t('api.actions.updateMulti.dialog.title')"
    :visible.sync="visible"
    custom-class="rwd-dialog">
    <el-alert
      class="multi-update-info"
      show-icon
      type="info"
      :title="title"
      :description="$t('api.actions.updateMulti.dialog.alert')"
      :closable="false"
      >
    </el-alert>
    <el-form
      label-position="top"
      :model="formData"
      ref="formData"
      >
      <text-field
        v-if="isShowIDs"
        v-model="formData.ids"
        type="textarea"
        base="actions.updateMulti"
        name="ids"
        :hasDesc="true"
        @input="inputIDs"
        >
      </text-field>
      <slot fields
        :data="formData"
        >
      </slot>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button
        @click="visible = false">
        {{ $t('api.cancelBtn') }}
      </el-button>
      <el-button type="primary"
        @click="save"
        :loading="loading"
        :disabled="ids.length <= 0"
        >
        {{ $t('api.saveBtn') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>

export default {
  name: 'multi-update-dialog',
  props: {
    base: {
      type: String,
      required: true
    },
    updateMulti: {
      type: Function,
      required: true
    },
    formData: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      formValid: () => {},
      ids: [],
      loading: false,
      visible: false,
      isShowIDs: false
    }
  },
  computed: {
    title: function () {
      return this.$t('api.multiActionInfo', {
        n: this.ids.length || 0
      })
    }
  },
  mounted () {
  },
  methods: {
    inputIDs (str) {
      this.ids = str.split(',').reduce((res, item) => {
        var i = item.trim()
        if (i.length > 0) {
          return res.concat(i)
        }
        return res
      }, [])
    },
    save () {
      this.updateMulti(this.ids)
    },
    show (vals) {
      this.isShowIDs = true
      this.ids = []
      if (vals.length > 0) {
        this.isShowIDs = false
        this.ids = vals
      }
      this.visible = true
    },
    hide () {
      this.visible = false
    }
  },
  watch: {
  }
}
</script>
